import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import {
  LOAD_INIT_DATA_FAILURE,
  LOAD_DATA_FULL_ERROR,
  THROTTLE_REQUESTS,
  LOADING_FULL_DATA,
  LOADING_INIT_DATA,
  LOAD_INIT_DATA_SUCCESS,
  START_TRACKING_INTERVAL,
  STOP_TRACKING_INTERVAL,
  LOAD_DATA_FULL_SUCCESS,
  LOAD_DATA_DYNAMIC_SUCCESS,
  LOAD_DATA_DYNAMIC_ERROR,
} from '../actions/api-actions';
import AppDataModel from '../models/app-data-model';
import { DEFAULT_FETCH_INTERVAL_IN_SECONDS } from '../constants/app-constants';
import {
  isSet,
  WEB_TRACKING_DETAILS_FLAGS,
} from '../common/utils/feature-flag';

export const AppDataReducer = (state = new AppDataModel(), action = {}) => {
  switch (action.type) {
    // QUESTION:: Do we need this?
    case THROTTLE_REQUESTS: {
      return {
        ...state,
        isRequestsThrottled: true,
      };
    }

    case START_TRACKING_INTERVAL: {
      const { intervalId } = action.data;
      return {
        ...state,
        trackingInterval: intervalId,
      };
    }

    case STOP_TRACKING_INTERVAL: {
      return {
        ...state,
        trackingInterval: null,
      };
    }

    // Use for loading trip data, it will trigger page level loading spinner
    case LOADING_INIT_DATA: {
      return {
        ...state,
        isLoadingInitData: true,
        isLoadedInitData: false,
      };
    }

    case LOAD_INIT_DATA_SUCCESS: {
      const { webTrackingDetails } = action.data;

      if (_isEmpty(webTrackingDetails))
        return {
          ...state,
          dataError: true,
          isLoadingInitData: false,
          isErrorInitData: true,
        };

      const enableInstruction = _get(
        webTrackingDetails,
        ['0', 'enableInstruction'],
        false,
      );

      const enableWebTrackingUICashlessPOD = _get(
        webTrackingDetails,
        ['0', 'enableWebTrackingUICashlessPOD'],
        false,
      );

      const featureFlag = _get(webTrackingDetails, ['0', 'featureFlag'], 0);

      const enableWebTrackingStayContactable = isSet(
        featureFlag,
        WEB_TRACKING_DETAILS_FLAGS.enableWebTrackingStayContactable,
      );

      const isExpired = _get(webTrackingDetails, ['0', 'isExpired'], true);

      const fetchInterval =
        _get(
          webTrackingDetails,
          ['0', 'interval'],
          DEFAULT_FETCH_INTERVAL_IN_SECONDS,
        ) * 1000;

      return {
        ...state,
        dataError: false,
        initDataLoaded: true,
        isLoadingInitData: false,
        isLoadedInitData: true,
        isExpiredGuid: isExpired,
        fetchInterval,
        enableInstruction,
        enableWebTrackingUICashlessPOD,
        enableWebTrackingStayContactable,
      };
    }

    case LOAD_INIT_DATA_FAILURE: {
      return {
        ...state,
        isLoadingInitData: false,
        isErrorInitData: true,
      };
    }

    // No usage now
    case LOADING_FULL_DATA: {
      return {
        ...state,
        isLoadingFullData: true,
        isLoadedFullData: false,
        isErrorFullData: false,
      };
    }

    case LOAD_DATA_FULL_ERROR: {
      return {
        ...state,
        isLoadingFullData: false,
        isErrorFullData: true,
      };
    }

    case LOAD_DATA_DYNAMIC_ERROR: {
      return {
        ...state,
        isLoadingDynamicData: false,
        isErrorDynamicData: true,
      };
    }

    case LOAD_DATA_FULL_SUCCESS:
    case LOAD_DATA_DYNAMIC_SUCCESS: {
      const { webTrackingDetails } = action.data;

      if (_isEmpty(webTrackingDetails))
        return {
          isExpiredGuid: true,
        };

      const isExpired = _get(webTrackingDetails, ['0', 'isExpired'], false);

      const fetchInterval =
        _get(
          webTrackingDetails,
          ['0', 'interval'],
          DEFAULT_FETCH_INTERVAL_IN_SECONDS,
        ) * 1000;

      return {
        ...state,
        isExpiredGuid: isExpired,
        isRequestsThrottled: false, // For legacy test case
        fetchInterval,
      };
    }

    default:
      return state;
  }
};

export default AppDataReducer;
